import { ref } from 'vue'

const messages = ref([])
let nextId = 0

function add(type, text, duration = 3500) {
  const id = ++nextId
  messages.value.push({ id, type, text })
  setTimeout(() => remove(id), duration)
}

function remove(id) {
  const idx = messages.value.findIndex(m => m.id === id)
  if (idx !== -1) messages.value.splice(idx, 1)
}

export const toast = {
  success: (text) => add('success', text),
  error:   (text) => add('error', text),
  info:    (text) => add('info', text),
  warning: (text) => add('warning', text),
}

export { messages, remove }
